export default __webpack_public_path__ + "static/patient-education-mobile-207c62d8ac335515ff0bee9e9195e6b2.png";